import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchInvoiceBatch,
  getCreditCardUrl,
  getCreditCardPaymentStatus,
} from "../store/actions";
import {
  InvoiceServices,
  CCModal,
  InvoiceBilling,
  InvoiceRequestor,
  InvoiceTerms,
} from "../components";

import { API_URL } from "../env";
//import CurrencyFormat from "react-currency-format";
const Invoice = () => {
  const { invoiceGuid } = useParams();
  const dispatch = useDispatch();
  const [showCCModal, updateShowCCModal] = useState(false);
  const [showPaymentButton, updateshowPaymentButton] = useState(false);
  const handleClose = () => updateShowCCModal(false);

  const { isLoading, invoice, modules, ccUrl, siteOrdered } = useSelector(
    (state) => state.invoice
  );

  useEffect(() => {
    dispatch(fetchInvoiceBatch(invoiceGuid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceGuid]);

  const viewPdf = () => {
    window.open(`${API_URL}/api/pdf/stream/${invoiceGuid}`, "_blank");
  };

  const payCreditCard = () => {
    window.open(`${ccUrl.url}`, "_blank");
  };

  useEffect(() => {
    if (invoice.date_payment_confirmed) {
      // updateShowCCModal(false);
      updateshowPaymentButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoice.date_payment_confirmed]);

  useEffect(() => {
    if (invoice.payment_type === "credit" && !invoice.date_payment_confirmed) {
      updateshowPaymentButton(true);
      dispatch(getCreditCardUrl(invoiceGuid));
      // updateShowCCModal(true);
    }

    if (invoice.date_payment_confirmed) {
      updateshowPaymentButton(false);
    }

    //fetch credit card payment status, if payment is confirmed,
    //Pay via CC is disabled
    if (invoice.payment_method_id === 2 && !invoice.date_payment_confirmed) {
      // dispatch(getCreditCardPaymentStatus(invoice.invoice_guid));

      let pollCount = 0;

      const interval = setInterval(() => {
        pollCount += 1;
        if (pollCount === 100 || invoice.date_payment_confirmed) {
          clearInterval(interval);
          // updateShowCCModal(false);
          updateshowPaymentButton(false);
        } else {
          dispatch(getCreditCardPaymentStatus(invoice.invoice_guid));
        }
      }, 6000);

      return () => clearInterval(interval);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoice.payment_type, invoice.date_payment_confirmed]);

  return (
    <div className="container">
      {/* <div>Invoice {invoiceGuid}</div> */}

      {isLoading.invoice || isLoading.modules ? (
        <div className="d-flex flex-column align-items-center">
          <span className="full-page-load">
            <div className="lds-facebook">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </span>
        </div>
      ) : (
        <>
          {false && (
            <CCModal
              show={showCCModal}
              handleClose={handleClose}
              iframeUrl={ccUrl.url}
              handleDownload={viewPdf}
            />
          )}

          <div className="d-flex justify-content-center align-items-center flex-column">
            <h1 className="mb-auto p-3">Thank you for your order! </h1>

            <div
              className="pt-3 col-md-6 col-sm-6 col-sm-offset-3 lead"
              style={{ textAlign: "center" }}
            >
              Your account will be renewed or activated upon receipt of payment
              and confirmation of organization information.

            </div>
            <div className="p-3" />

            <div className="row">
              <div className="md-auto" style={{ textAlign: "center" }}>
                <button className="btn btn-secondary" onClick={viewPdf}>
                  <i className="fa fa-file-pdf-o fa-lg p-2"></i>
                  Download Invoice
                </button>
              </div>

              {showPaymentButton && (
                <div className="md-auto mt-2" style={{ marginTop: "10px", textAlign: "center" }}>
                  <button
                    className="btn btn-primary"
                    onClick={payCreditCard}
                  >
                    <i className="fa fa-credit-card fa-lg p-2"></i>
                    Pay via credit card
                  </button>
                  <div><small>(This payment link is securely provided and protected by the University of Oregon.)</small></div>
                </div>
              )}
              {
                invoice.date_payment_confirmed && (
                  <div>
                    <div className="alert alert-success mt-2" role="alert">
                      <i className="fa fa-check-circle"></i> Payment has been
                      confirmed.
                    </div>
                  </div>
                )
              }

            </div>
          </div>
          <div className="p-3" />

          <div className="d-flex d-flex-row justify-content-between flex-wrap pt-4">
            <InvoiceBilling invoice={invoice} />

            <div className="d-none d-lg-block">
              <InvoiceRequestor invoice={invoice} />
            </div>

            <InvoiceTerms invoice={invoice} />
          </div>

          <InvoiceServices invoice={invoice} modules={modules} siteOrdered={siteOrdered} />
        </>
      )}
      <div className="mt-4" />
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12 d-flex align-items-center justify-content-end">
              <div className="footer-copyright">
                ©2026 <a href="https://intocareers.net" target="_blank" rel="noreferrer" className="text-white">intoCareers</a>, <a href="https://uoregon.edu" target="_blank" rel="noreferrer" className="text-white">University of Oregon</a>. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Invoice };
